import React, { Component } from "react";
import Chart from "chart.js";
import { getChartData, getExchangeRate } from "../../util/utils";
// import { logger } from "../../util/logger";
//import Load from "../../assets/svg/other/loading2.svg";
//import Load2 from "../../assets/svg/icons-new/ball.svg";
import Loadlogo from "../../assets/svg/btmlogo.svg";

export default class ethGraph extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ethNgnPrice: "",
      ethGhsPrice: "",
      ethPrice: "",
      chartData: [],
      chartFormat: [],
      chartPeriod: " ",
      chartPeriodtxt: "Data over the past month",
      isLoaded: false,
    };
  }

  loadPrices = async () => {
    const ngnPrice = await getExchangeRate("ethngn", "buy");
    const ghsPrice = await getExchangeRate("ethghs", "buy");
    const usdPrice = await getExchangeRate("ethusd", "buy");

    this.setState({
      ethNgnPrice: ngnPrice,
      ethGhsPrice: ghsPrice,
      ethPrice: usdPrice,
    });
  };

  loadChartPrices = async () => {
    this.setState({
      isLoaded: false,
      chartPeriod: "Monthly",
      chartPeriodtxt: "Data over the past month",
    });
    const chartData = await getChartData("ethereum", 30, 30, 24, "daily");
    this.setState({
      chartData,
      isLoaded: true,
    });

    let myChart1 = document.getElementById("myChart1").getContext("2d");
    ///
    Chart.defaults.global.defaultFontSize = 11;
    Chart.defaults.global.defaultFontColor = "#14142b4f";
    //Chart.defaults.global.defaultFontColor = "#fff";

    new Chart(myChart1, {
      type: "line", // bar, horizontalBar, pie, line, doughnut, radar, polarArea
      data: {
        labels: this.state.chartData.dates,
        datasets: [
          {
            label: "Amount in USD",
            // fill: false,
            lineTension: 0.5,
            //barThickness: 6,
            //maxBarThickness: 8,
            //minBarLength: 34,
            backgroundColor: "#ffff",
            borderColor: "#03a438",
            borderWidth: 3.5,

            //hoverBorderWidth:3,
            //hoverBorderColor:'#000'
            pointRadius: 0.5,
            // pointBorderWidth:2,
            // pointHoverRadius:7,
            //pointHoverBorderWidth:10,
            //pointBorderColor:'white',
            pointBackgroundColor: "white",
            //pointHoverBackgroundColor:'#bcc',
            pointRotation: 1,
            data: this.state.chartData.prices,
          },
        ],
      },
      options: {
        legend: {
          display: false,
          position: "right",
          labels: {
            fontColor: "white",
          },
        },
        scales: {
          yAxes: [
            {
              display: false,
              ticks: {
                //min: 10000,
                beginAtZero: true,
                showLabelBackdrop: true,
              },
              gridLines: {
                display: false,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                offsetGridLines: true,
                display: false,
              },
            },
          ],
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            bottom: 0,
            top: 0,
          },
        },

        tooltips: {
          enabled: true,
        },
      },
    });
  };

  loadWeeklyPrices = async () => {
    //event.preventDefault();
    this.setState({
      isLoaded: false,
      chartPeriodtxt: "Data over the past week",
      chartPeriod: "Weekly",
    });
    try {
      const chartData = await getChartData("ethereum", 7, 7, 24, "daily");
      await this.setState({
        chartData,
        isLoaded: true,
      });
      //logger("state week",this.state.chartData)
    } catch (err) {}

    let myChart1 = document.getElementById("myChart1").getContext("2d");
    ///
    Chart.defaults.global.defaultFontSize = 11;
    Chart.defaults.global.defaultFontColor = "#14142b4f";
    // Chart.defaults.global.defaultFontColor = "#fff";

    new Chart(myChart1, {
      type: "line", // bar, horizontalBar, pie, line, doughnut, radar, polarArea
      data: {
        labels: this.state.chartData.dates,
        datasets: [
          {
            label: "Amount in USD",
            // fill: false,
            lineTension: 0.5,
            //barThickness: 6,
            //maxBarThickness: 8,
            //minBarLength: 34,
            backgroundColor: "#ffff",
            borderColor: "#03a438",
            borderWidth: 3.5,

            //hoverBorderWidth:3,
            //hoverBorderColor:'#000'
            pointRadius: 0.5,
            // pointBorderWidth:2,
            // pointHoverRadius:7,
            //pointHoverBorderWidth:10,
            //pointBorderColor:'white',
            pointBackgroundColor: "white",
            //pointHoverBackgroundColor:'#bcc',
            pointRotation: 1,
            data: this.state.chartData.prices,
          },
        ],
      },
      options: {
        legend: {
          display: false,
          position: "right",
          labels: {
            fontColor: "white",
          },
        },
        scales: {
          yAxes: [
            {
              display: false,
              ticks: {
                //min: 10000,
                beginAtZero: true,
                showLabelBackdrop: true,
              },
              gridLines: {
                display: false,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                offsetGridLines: true,
                display: false,
              },
            },
          ],
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            bottom: 0,
            top: 0,
          },
        },

        tooltips: {
          enabled: true,
        },
      },
    });
  };

  loadDailyPrices = async () => {
    this.setState({
      isLoaded: false,
      chartPeriodtxt: "Data over the past 24 hours",
      chartPeriod: "Daily",
    });
    try {
      const chartData = await getChartData("ethereum", 1, 1, 24, "hourly");
      await this.setState({
        chartData,
        isLoaded: true,
      });
    } catch (err) {}

    let myChart1 = document.getElementById("myChart1").getContext("2d");
    ///
    Chart.defaults.global.defaultFontSize = 11;
    Chart.defaults.global.defaultFontColor = "#14142b4f";
    // Chart.defaults.global.defaultFontColor = "#fff";

    new Chart(myChart1, {
      type: "line", // bar, horizontalBar, pie, line, doughnut, radar, polarArea
      data: {
        labels: Object.keys(this.state.chartData.dates),
        datasets: [
          {
            label: "Amount in USD",
            // fill: false,
            lineTension: 0.5,
            //barThickness: 6,
            //maxBarThickness: 8,
            //minBarLength: 34,
            backgroundColor: "#ffff",
            borderColor: "#03a438",
            borderWidth: 3.5,

            //hoverBorderWidth:3,
            //hoverBorderColor:'#000'
            pointRadius: 0.5,
            // pointBorderWidth:2,
            // pointHoverRadius:7,
            //pointHoverBorderWidth:10,
            //pointBorderColor:'white',
            pointBackgroundColor: "white",
            //pointHoverBackgroundColor:'#bcc',
            pointRotation: 1,
            data: this.state.chartData.prices,
          },
        ],
      },
      options: {
        legend: {
          display: false,
          position: "right",
          labels: {
            fontColor: "white",
          },
        },
        scales: {
          yAxes: [
            {
              display: false,
              ticks: {
                //min: 10000,
                beginAtZero: true,
                showLabelBackdrop: true,
              },
              gridLines: {
                display: false,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                offsetGridLines: true,
                display: false,
              },
            },
          ],
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            bottom: 0,
            top: 0,
          },
        },

        tooltips: {
          enabled: true,
        },
      },
    });
  };

  async componentDidMount() {
    await this.loadChartPrices();

    await this.loadPrices();
  }
  render() {
    const { selectedCurrency } = this.props;
    return (
      <div>
        <div>
          {this.state.isLoaded ? (
            <section className="chart1">
              <p className="crypto-prices">
                1 ETH = {Number(this.state.ethPrice).toLocaleString() + " "}USD,{" "}
                {Number(this.state.ethNgnPrice).toLocaleString() + " "} NGN,{" "}
                {Number(this.state.ethGhsPrice).toLocaleString() + " "} GHS
              </p>

              <p className="hide-prices">
                1 ETH = {Number(this.state.ethPrice).toLocaleString() + " "}
                USD,{" "}
                {selectedCurrency === "naira" &&
                  `${Number(this.state.ethNgnPrice).toLocaleString() + " "}NGN`}
                {selectedCurrency === "cedis" &&
                  `${Number(this.state.ethGhsPrice).toLocaleString() + " "}GHS`}
              </p>
              <div className="graph-tabs">
                <button
                  className={`graph-tab right-p2p ${
                    this.state.chartPeriod === "Monthly" ? "type-active" : ""
                  }`}
                  onClick={this.loadChartPrices}>
                  PAST MONTH
                </button>

                <button
                  className={`graph-tab right-p2p ${
                    this.state.chartPeriod === "Weekly" ? "type-active" : ""
                  }`}
                  onClick={this.loadWeeklyPrices}>
                  PAST WEEK
                </button>

                <button
                  className={`graph-tab right-p2p ${
                    this.state.chartPeriod === "Daily" ? "type-active" : ""
                  }`}
                  onClick={this.loadDailyPrices}>
                  PAST 24HRS
                </button>
              </div>
              <p className="graph-period">{this.state.chartPeriodtxt}</p>
              {/* <canvas id="myChart1" height="130"></canvas> */}
              <canvas id="myChart1" className="canvas-ch" height="120"></canvas>
            </section>
          ) : (
            // <div className="graph-loading2">
            //   <img src={Load2} alt="loading" />
            // </div>
            <div className="loading-logo2" id="loadlogo">
              <img src={Loadlogo} alt="loading" />
            </div>
          )}
        </div>
      </div>
    );
  }
}
